export default "__VITE_ASSET__9e58076f__"